export default "__VITE_ASSET__X_ok7drc__"